import { useInView } from 'react-intersection-observer';
import { useEffect, useState } from 'react';

const AltTitle = ({text, specialClass}) => {

  const [ref, inView, entry] = useInView({
    threshold: 1,
    triggerOnce: true,
    delay: 500
  });


  return (
    <h1 className={`alt-title red-white-text ${inView && "alt-visible"} ${specialClass}`} ref={ref}>
      {
        text
      }
    </h1>
  )
}

export default AltTitle;